export default function getAllergyPreferenceLabel(allergies?: string[]): string {
  if (!allergies || !allergies.length) return "None"

  if (allergies.length == 1) return allergies[0]

  return allergies[0] + " + " + (allergies.length - 1)
}
